import axios from 'axios'
const KnowledgeModule = {
  namespaced: true,
  state: {
    knowledges: [],
    selectedKnowledgeId: ''
  },
  mutations: {
    SET_SELECTED: (state, payload) => {
      state.selectedKnowledgeId = payload
    },
    FETCH: (state, payload) => {
      state.knowledges = payload
    }
  },
  actions: {
    async fetch({ commit }) {
      try {
        const response = await axios.get(`portal/knowledge`)
        commit('FETCH', response.data)
      } catch (error) {
        // const notification = {
        //   type: 'error',
        //   message: 'Knowledge was a problem: ' + error.message
        // }
        // dispatch('Notification/add', notification, { root: true })
        throw new Error(error)
      }
    }
  },
  getters: {
    getAll: state => {
      return state.knowledges
    }
  }
}

export default KnowledgeModule
